import { EntityType } from "../../Onboarding/types";

const SDK_ID_TO_INTERNAL: Record<string, EntityType> = {
  business: "Business",
  individual: "Individual"
};

export const parseAllowedEntityTypes = (queryParam: string): EntityType[] => {
  const result: EntityType[] = [];

  queryParam
    .split(",")
    .map(value => value.trim())
    .filter(Boolean)
    .forEach(value => {
      const mapped = SDK_ID_TO_INTERNAL[value];
      if (mapped && !result.includes(mapped)) {
        result.push(mapped);
      }
    });

  return result;
};
